<template>
  <div>
    <h2 class="section-title m-4 text-center text-lg px-5 py-3">お知らせ</h2>
    <div v-if="message" class="article">
      <div class="article__header">
        <div class="article__title">{{ message.title }}</div>          
        <div class="article__timestamp">{{ getMoment(message.dispDate) }}</div>
      </div>
      <div class="py-3" :class="$style.message_detail" v-html="messageChange(message.detail)"></div>
    </div>
    <div class="mt-4">
      <button @click="backNews" class="back_button">
        <span class="w-full -ml-5">一覧へ戻る</span></button>
    </div>
  </div>
</template>
  
  <script>
  import moment from "moment";
  import { mapGetters } from 'vuex'
  
  export default {
    data () {
      return {
        message: {}
      }
    },
    created() {
      this.no = this.$route.params.no
      this.message = this.notice.find((msg) => msg.id == this.no);
  },
    name: 'NewsDetail',
    mounted() {
      this.$store.dispatch('notice/fetchAll')
    },
    computed: {
      ...mapGetters({
        notice: 'notice/getAll',
        alreadyRead: 'notice/getAlreadyRead'
      })
    },
    methods: {
      backNews: function () {
        this.$router.push( {name: 'news', params: { lang: this.lang } })
      },
      getMoment: function (date) {
        return moment(date).format('YYYY/MM/DD')
      },
      messageChange: function (msg) {
        return msg.replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('\n', '<br />')
      },

    }
}
  </script>
<style lang="scss" scoped>
.article {
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  word-break: break-all;
  border-radius: 8px;
  background-color: #fff;
  grid-gap: 16px;
  gap: 16px;
}
.article__header {
  grid-gap: 6px;
  gap: 6px;
  display: flex;
  flex-direction: column;
}
.article__title {
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
}
.article__timestamp {
    color: #75828d;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
}
.article p{
  text-align: justify;
  font-size: 16px;
  margin-bottom: 12px;
  color: #313234;
  line-height: 1.5;
}

.back_button{
  margin-top: 24px;
  margin-right: 16px;
  margin-left: 16px;
  display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;
    height: 52px;
    width: calc(100% - 32px);
    padding: 0 12px;
    text-align: center;
    text-decoration: none;
    box-sizing: border-box;
    border: 1px solid #313234;
    border-radius: 100px;
    background-color: #fff;
    color: #313234;
}
</style>

<style module>
.message_detail > a{
  color: #2F8DB7;
  font-weight: bold;
  text-decoration: underline;
}
</style>